import Vue from 'vue'
import Vuex from 'vuex'

import schedule from '@/store/schedule'
import dictionaries from '@/store/dictionaries'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,

  modules: {
    schedule,
    dictionaries
  }
})
